import { memo, useMemo } from 'react'
import Icon from 'components/core/Icon/Icon'
import Layout from 'components/core/Layout/Layout'
import Modal from 'components/interface/Modal/Modal'

/**
 * The `ModalLearnUtility`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function ModalLearnUtility (props) {
  const title = useMemo(() => <h1>About Compatibility</h1>, [])

  return (
    <Modal.Container size="x-small">
      <Modal.Media size="small">
        <Icon icon="lock" />
      </Modal.Media>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Body>
        <Layout.Body align="center">
          <p>Learn more</p>
        </Layout.Body>
      </Modal.Body>
      <Modal.Footer />
    </Modal.Container>
  )
}

/** @type {object} */
ModalLearnUtility.propTypes = {}

/** @type {object} */
ModalLearnUtility.defaultProps = {}

// Memoize
export default memo(ModalLearnUtility)
